import { Alert, Button, Skeleton } from 'antd';

/** Render the prepared read projection inside Canvas so closing also cancels its owner. */
export const ArtifactReadState = ({ state, onClose, children }) => {
  const presentation = state?.presentation;
  if (!presentation?.showFeedback) return children;
  return <div className="flare-canvas-panel" role="status" aria-live="polite" aria-label={presentation.message}
    style={{ display: 'flex', flexDirection: 'column', gap: 16, height: '100%', minHeight: 180, padding: 24 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>工作台</span><Button aria-label="关闭工作台" onClick={onClose}>关闭</Button>
    </div>
    {presentation.pending ? <><span>{presentation.message}</span><Skeleton active /></>
      : <Alert type="error" showIcon title="产物打开失败" description={presentation.message} />}
    {presentation.canRetry && <Button onClick={state.retry}>重试</Button>}
  </div>;
};
